import * as Constants from '../constants';

const initialState = {
  isLoading: true,
  error: null,
  dataFilter: {
    lookback: 90,
    emailType: 'commercial',
    eventType: 'open',
    openRateWeight: 1,
    clickRateWeight: 0,
    unsubscribePenaltyFactor: 0,
    rangeStart: null,
    rangeEnd: null
  },
  chartParams: {
    lookback: 90,
    emailType: 'commercial',
    eventType: 'open'
  },
  einsteinFrequencyRecs: {
    expectedGain: 0,
    oversaturation: 0,
    undersaturation: 0
  },
  saveSuccess: null
};

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.REQUEST_DATA_EXTENSION:
      return { ...state, isLoading: true };
    case Constants.RECEIVE_DATA_EXTENSION:
      if (action.error) {
        console.log(`Receive Data Extension Error  ${action.error}`);
        return {
          ...state,
          isLoading: false,
          exists: false,
          error: action.error
        };
      }
      return {
        ...state,
        isLoading: false,
        data: action.dataExtension,
        exists: true
      };
    case Constants.REQUEST_CREATE_DATA_EXTENSION:
      return {
        ...state,
        isLoading: false,
        saveSuccess: null,
        error: null
      };
    case Constants.RECEIVE_CREATE_DATA_EXTENSION:
      if (action.error) {
        console.log(`Receive Create Data Extension Error  ${action.error}`);
        return {
          ...state,
          isLoading: false,
          error: action.error,
          saveSuccess: false
        };
      }
      return {
        ...state,
        data: {
          ...state.dataFilter
        },
        isLoading: false,
        saveSuccess: true,
        exists: true
      };
    case Constants.REQUEST_UPDATE_DATA_EXTENSION:
      return {
        ...state,
        isLoading: false,
        saveSuccess: null,
        error: null
      };
    case Constants.RECEIVE_UPDATE_DATA_EXTENSION:
      if (action.error) {
        console.log(`Receive Create Data Extension Error  ${action.error}`);
        return {
          ...state,
          isLoading: false,
          error: action.error,
          saveSuccess: false
        };
      }
      return {
        ...state,
        data: {
          ...state.dataFilter
        },
        isLoading: false,
        saveSuccess: true,
        exists: true
      };
    case Constants.UPDATE_DATA_FILTER:
      return {
        ...state,
        error: null,
        saveSuccess: false,
        dataFilter: {
          ...state.dataFilter,
          ...action.dataFilter
        }
      };
    case Constants.UPDATE_ADVANCED_SLIDERS:
      return {
        ...state,
        advancedSliders: action.advancedSliders
      };
    case Constants.UPDATE_CHART_PARAMS:
      return {
        ...state,
        chartParams: action.chartParams
      };
    case Constants.UPDATE_FREQUENCY_RECS:
      return {
        ...state,
        einsteinFrequencyRecs: action.einsteinFrequencyRecs,
        dataFilter: {
          ...state.dataFilter,
          oversaturated: action.einsteinFrequencyRecs.oversaturated,
          undersaturated: action.einsteinFrequencyRecs.undersaturated
        }
      };

    default:
      return state;
  }
}
